import { render, staticRenderFns } from "./PositionHistory.vue?vue&type=template&id=2dd5b568&scoped=true&lang=pug&"
import script from "./scripts/PositionHistory.js?vue&type=script&lang=js&"
export * from "./scripts/PositionHistory.js?vue&type=script&lang=js&"
import style0 from "./PositionHistory.vue?vue&type=style&index=0&id=2dd5b568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5b568",
  null
  
)

export default component.exports